/*
 * Get Paged Data Plugin
 *
 * HandleBars required!
 */
/* eslint-disable */
!(function (root, factory) {
    'use strict';

    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['app', 'jquery'], factory);
    } else if (typeof exports === 'object') {
        // Node/CommonJS
        module.exports = factory(require('app'), require('jquery'));
    } else {
        // Browser globals

        root.APP = root.APP || {};
        root.APP.init = root.APP.init || {};

        factory(root.APP, root.jQuery);
    }
}(this, function (APP, $) {
    'use strict';

    APP.init.getPagedData = function (opts) {
        var options = $.extend({}, opts);

        function showMore(target, template, settings) {

            var isExtend = false,
                currentPageIndex = 2,
                container = $(target),
                showMoreBtn = $('[data-target="' + APP.sanitizeXss(target.data('showmore')) + '"]');

            var showMoreBtnInnerHtml = showMoreBtn.html(),
                tmpl = $(template).html(),
                compiled = Handlebars.compile(tmpl); // eslint-disable-line

            var pageSize = parseInt(container.data('size') || 10, 10);

            function setItem(data) {

                currentPageIndex++;
                container.append(compiled(data));

                if (isExtend === false && currentPageIndex > 1) {
                    isExtend = true;
                    showMoreBtn.removeClass('d-none');
                }

                // no data fix

                if (!APP.Helper.is.undefined(data.nextData)) {
                    showMoreBtn[data.nextData !== true ? 'addClass' : 'removeClass']('d-none');
                }
            }

            function sendViaAjax() {
                var dt = { page: currentPageIndex },
                    form = $(settings.toForm || APP.sanitizeXss(showMoreBtn.data('form')));

                showMoreBtn.prop('disabled', true).html(options.btnLoadingText);
                form.variables = {};

                var formData = APP.Helper.getFormData(form);

                const endpoint = new URL(settings.url);
                const urlSearchParams = new URLSearchParams(endpoint.search);
                const paramsString = Object.fromEntries(urlSearchParams.entries());
                const params = JSON.parse(paramsString.parameters)

                if (formData.year) {
                    params.yearParam = formData.year;
                }

                if (formData.page === '0') {
                    params.from = 0;
                } else {
                    params.from = ((dt.page - 1) * pageSize);
                }

                settings.url = `${endpoint.origin}${endpoint.pathname}?parameters=${JSON.stringify(params)}`;

                if (formData.page) {
                    dt.page = formData.page;
                    currentPageIndex = formData.page;
                    if (formData.page === '0') {
                        currentPageIndex = 1;
                        dt.page = 2;
                    }
                }

                return APP.Helper.sendRequest(form, settings).done(function (data) {
                    try {
                        const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
                        data.items.forEach(item => {
                            item.CreatedUtc = new Date(item.CreatedUtc).toLocaleDateString('tr-TR', options)
                            if (item[item.ContentType] && item[item.ContentType].DateTimeCreated)
                                item[item.ContentType].DateTimeCreated.Value = new Date(item[item.ContentType].DateTimeCreated.Value).toLocaleDateString('tr-TR', options)
                        })
                    } catch (error) { /**/ }
                    setItem(data);

                    showMoreBtn.prop('disabled', false).html(showMoreBtnInnerHtml);
                }).catch(function () {
                    // TODO: LOG HERE
                });
            }

            showMoreBtn.click(function (e) {
                if (this.nodeName == "SELECT")
                    return;
                e.preventDefault();
                sendViaAjax();
            });
        }

        $('[data-showmore]').each(function () {

            var type = APP.sanitizeXss($(this).data('showmore')),
                opts = options[type] || {},
                template = APP.sanitizeXss($(this).data('template'));

            opts.url = !opts.url ? APP.sanitizeXss($(this).data('url')).split('|')[0] : opts.url;
            opts.method = !opts.method ? APP.sanitizeXss($(this).data('url')).split('|')[1] || 'GET' : opts.method;

            showMore($(this), template, opts);
        });
    }

}));
